var WarmupQuestions = require("lib/academic/WarmupQuestions");
var TopicQuestion = require("components/writing/quizzes/warmups/TopicQuestion");

class NonFictionPointOfViewQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isPictureBook() {
		if (this.props.answers[TopicQuestion.STEM]) {
			return this.props.answers[TopicQuestion.STEM][TopicQuestion.TEXT_TYPE] == "picture book";
		}
	}

	getDisplayStatus() {
		var answers = this.props.answers[NonFictionPointOfViewQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			if (this.props.level == "1") {
				return [NAMING_STAGE];
			} else {
				return [PURPOSE_STAGE];
			}
		}

		if (this.props.level == "1") {
			if (!answers[AUTHOR] || (this.isPictureBook() && !answers[ILLUSTRATOR])) {
				return [NAMING_STAGE];
			} else {
				return [NAMING_STAGE, true];
			}
		}

		var purpose = answers[PURPOSE_TYPE];
		if (!purpose) {
			return [PURPOSE_STAGE];
		}

		if (purpose.includes("entertain")) {
			var stageName = ENTERTAIN_STAGE;
		} else if (purpose.includes("describe")) {
			var stageName = DESCRIBE_STAGE;
		} else if (purpose.includes("inform")) {
			var stageName = INFORM_STAGE;
		} else if (purpose.includes("persuade")) {
			var stageName = PERSUADE_STAGE;
		}

		if ((this.props.level == "2" && !answers[PURPOSE_DESCRIPTION]) || (this.props.level == "3" && !answers[PURPOSE_SOURCE])) {
			return [stageName];
		} else {
			return [stageName, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		if (this.props.level == "1") {
			if (this.isPictureBook()) {
				var illustratorDisplay = (
					<div>
						{ this.props.getTextF("label2", NAMING_STAGE) }
						{ this.props.renderInputF(ILLUSTRATOR) }
					</div>
				);
			}

			var namingDisplay = (
				<div>
					{ this.props.getTextF("label1", NAMING_STAGE) }
					{ this.props.renderInputF(AUTHOR) }
					{ illustratorDisplay }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 0) {
			var purposeDisplay = (
				<div>
					{ this.props.getTextF("label1", PURPOSE_STAGE) }
					{ this.props.renderDropdownF("choices1", PURPOSE_STAGE, PURPOSE_TYPE, [PURPOSE_TYPE]) }.
				</div>
			);
		}


		if (_.indexOf(STAGES, stage) > 1) {
			if (this.props.level == "2") {
				var inputDisplay = this.props.renderInputF(PURPOSE_DESCRIPTION);
			} else {
				var inputDisplay = this.props.renderDropdownF("choices1", stage, PURPOSE_SOURCE);
			}

			var purposeInfoDisplay =  (
				<div>
					{ this.props.getTextF("label1", stage) }
					{ inputDisplay }.
				</div>
			);
		}

		return (
			<div>
				{ namingDisplay }
				{ purposeDisplay }
				{ purposeInfoDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

NonFictionPointOfViewQuestion.STEM = "nfpov";

// stages
var NAMING_STAGE = "naming";
var PURPOSE_STAGE = "purpose";
var ENTERTAIN_STAGE = "entertain";
var DESCRIBE_STAGE = "describe";
var INFORM_STAGE = "inform";
var PERSUADE_STAGE = "persuade";

var STAGES = [
	NAMING_STAGE, PURPOSE_STAGE, ENTERTAIN_STAGE, DESCRIBE_STAGE, INFORM_STAGE, PERSUADE_STAGE
];

// answer keys
var AUTHOR = "author";
var ILLUSTRATOR = "illustrator";
var PURPOSE_TYPE = "purpose_type";
var PURPOSE_SOURCE = "purpose_source";
var PURPOSE_DESCRIPTION = "purpose_description";

NonFictionPointOfViewQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = NonFictionPointOfViewQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/NonFictionPointOfViewQuestion.js